import React, { useEffect, useState } from "react";

const Defaultinput = ({
  handleChangeChatData,
  addMessagesWithDelay,
  suggestedText,
  onDraftChange,
  leadId,
  isSuggested = false,
}) => {
  const [inputValue, setInputValue] = useState("");
  // Default to SMS so Manual mode does not use CHAT/AI by accident
  const [selectedChannel, setSelectedChannel] = useState("SMS");
  // Default to true so send button works when consent UI is hidden (checkbox is commented out)
  const [smsConsent, setSmsConsent] = useState(true);
  const consentKey = leadId ? `smsConsent:${String(leadId)}` : undefined;
  
  // Manual leads should NOT use AI; we always send via external channels (SMS/EMAIL)
  const isManualLead = !isSuggested;
  
  // Debug logging
  console.log('🔍 [DEBUG] DefaultInput render:', {
    isSuggested,
    isManualLead,
    selectedChannel,
    leadId
  });

  useEffect(() => {
    if (typeof suggestedText === "string") {
      setInputValue(suggestedText);
    }
  }, [suggestedText]);

  // Initialize consent from localStorage per lead
  useEffect(() => {
    try {
      if (consentKey) {
        const saved = localStorage.getItem(consentKey);
        if (saved === 'true') setSmsConsent(true);
      }
    } catch {}
  }, [consentKey]);

  // Persist consent when it becomes true
  useEffect(() => {
    try {
      if (consentKey) {
        if (smsConsent) localStorage.setItem(consentKey, 'true');
      }
    } catch {}
  }, [smsConsent, consentKey]);

  // Reset consent when channel changes away from SMS (UI gating only; does not clear saved consent)
  useEffect(() => {
    if (selectedChannel !== "SMS" && smsConsent) {
      setSmsConsent(false);
    }
  }, [selectedChannel, smsConsent]);

  const submit = () => {
    const text = (inputValue || "").trim();
    if (!text) return;
    
    // Always use selected external channel (Manual mode should not trigger AI/CHAT)
    const channel = selectedChannel;

    // Gate SMS sends behind consent checkbox
    if (channel === "SMS" && !smsConsent) {
      return;
    }
    handleChangeChatData(text, channel);
    
    // Removed transient placeholder bubble that showed "just now" with empty text
    setInputValue("");
    onDraftChange && onDraftChange("");
  };

  const handleInputKeyDown = (event) => {
    if (event.key === "Enter") {
      // Prevent sending via Enter if SMS consent not provided
      if (selectedChannel === "SMS" && !smsConsent) {
        event.preventDefault();
        return;
      }
      submit();
    }
  };

  return (
    <div className="flex justify-center w-full">
      <div className="w-[74%] relative mt-3 mb-6">
        {/* Header: left shows consent (if needed); right always shows channel selector */}
        <div className="mb-2 flex items-center justify-between">
          {/* {selectedChannel === "SMS" && !localStorage.getItem(consentKey || '') ? (
            <div className="mx-1 text-[12px] text-darkGray flex items-center gap-2">
              <input
                id="sms-consent"
                type="checkbox"
                checked={smsConsent}
                onChange={(e) => setSmsConsent(e.target.checked)}
                className="mt-[1px]"
              />
              <label htmlFor="sms-consent" className="leading-snug">
                I confirm recipient consent for SMS. <span className="underline cursor-help" title="By sending, you confirm prior express consent to receive SMS updates. Message/data rates may apply. Reply STOP to opt out.">Details</span>
              </label>
            </div>
          ) : <div />} */}
          <select
            value={selectedChannel}
            onChange={(e) => setSelectedChannel(e.target.value)}
            className="text-sm px-4 py-2 pr-8 border border-lightGray rounded-full bg-white text-darkGray shadow-sm focus:border-darkBlue focus:ring-2 focus:ring-darkBlue/30 hover:border-darkBlue transition-colors outline-none"
          >
            <option value="SMS">📱 Send via SMS</option>
            <option value="EMAIL">📧 Send via Email</option>
          </select>
        </div>
        {/* Temporary: show full consent text visibly for screenshots */}
        {/* {!isManualLead && selectedChannel === "SMS" && (
          <div className="-mt-1 mb-2 mx-1 text-[12px] text-darkGray bg-lightestGray border border-lightGray rounded-md px-3 py-2">
            By sending, you confirm prior express consent to receive SMS updates. Message/data rates may apply. Reply STOP to opt out.
          </div>
        )} */}
        
        <input
          value={inputValue}
          onChange={(e) => {
            const v = e.target.value;
            setInputValue(v);
            onDraftChange && onDraftChange(v);
          }}
          type="text"
          onKeyDown={handleInputKeyDown}
          placeholder="Type your message here..."
          className="w-full pl-6 py-4 pr-11 text-h3 font-medium text-darkestSlate placeholder:text-mediumGray bg-lightestGray border border-lightGray rounded-[64px] outline-none focus:border-darkBlue"
        />
        <button
          // disabled={!inputValue || (selectedChannel === "SMS" && !smsConsent && !localStorage.getItem(consentKey || ''))}
          onClick={submit}
          className="absolute right-[24px] bottom-4"
          style={{ background: "none", border: "none", padding: 0 }}
        >
          <i className="fa-solid fa-paper-plane text-darkGray"></i>
        </button>
      </div>
    </div>
  );
};

export default Defaultinput;